import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import { convertBooleansToStrings } from './swift-id-application.transformer';
import type { SwiftIdApplicationCollection } from './swift-id-application.types';

export function swiftIdApplicationBackend(): Backend<SwiftIdApplicationCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'swift-id/application.php',
      method: 'GET',
      isGaf: true,
      params: {
        id: ids,
      },
    }),
    push: (_, swiftIdApplication) => ({
      endpoint: `swift-id/application.php`,
      method: 'POST',
      isGaf: true,
      payload: {
        application: convertBooleansToStrings(swiftIdApplication.data),
      },
    }),
    set: (_, swiftIdApplication) => ({
      endpoint: `swift-id/application.php`,
      method: 'PUT',
      isGaf: true,
      payload: {
        id: swiftIdApplication.id,
      },
    }),
    update: undefined,
    remove: undefined,
  };
}
